<section>
    <div class="title">
        <h2 id="title">{{ planSwitchPageData.pageTitle }}</h2>
    </div>
    <xm-bucket-switch
        [availablePlanOptions]="availablePlanOptions"
        [pageData]="planSwitchPageData"
        [accountSummary]="accountSummary"
        [user]="user"
        [lineSummary]="lineSummary"
        (selectedPlanObject)="navigateTo($event)"
        [showIcopPromotions]="showIcopPromotions">
    </xm-bucket-switch>
</section>
